import { gql } from '@apollo/client';

export const UpdateMyNotificationSetting = gql`
  mutation UpdateMyNotificationSetting(
    $eventRegistrationOpen: Boolean
    $eventRegistrationClosingReminder: Boolean
    $eventRegistrationClosed: Boolean
    $eventUpcomingReminder: Boolean
    $newAnnouncement: Boolean
    $weightUpdateReminder: Boolean
    $eventRegistrationOpenEmail: Boolean
    $eventRegistrationClosingReminderEmail: Boolean
    $eventRegistrationClosedEmail: Boolean
    $eventUpcomingReminderEmail: Boolean
    $newAnnouncementEmail: Boolean
    $weightUpdateReminderEmail: Boolean
  ) {
    updateMyNotificationSetting(
      eventRegistrationOpen: $eventRegistrationOpen
      eventRegistrationClosingReminder: $eventRegistrationClosingReminder
      eventRegistrationClosed: $eventRegistrationClosed
      eventUpcomingReminder: $eventUpcomingReminder
      newAnnouncement: $newAnnouncement
      weightUpdateReminder: $weightUpdateReminder
      eventRegistrationOpenEmail: $eventRegistrationOpenEmail
      eventRegistrationClosingReminderEmail: $eventRegistrationClosingReminderEmail
      eventRegistrationClosedEmail: $eventRegistrationClosedEmail
      eventUpcomingReminderEmail: $eventUpcomingReminderEmail
      newAnnouncementEmail: $newAnnouncementEmail
      weightUpdateReminderEmail: $weightUpdateReminderEmail
    ) {
      id
    }
  }
`;
